<template>
  <div>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="editItem = {}"
    >
      Add Client Database
    </v-btn>
    <client-database-table-modal v-if="editItem" :edited-item="editItem" @close="editItem = null" />
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      class="elevation-1"
      item-key="databaseId"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td class="justify-center">
            <v-btn tooltip.hover title="Edit client database" icon class="mx-0" @click="editItem = cloneDeep(props.item)">
              <v-icon color="primary">edit</v-icon>
            </v-btn>
          </td>
          <td>{{ props.item.userName }}</td>
          <td>{{ props.item.connectionUrl }}</td>
          <td>{{ props.item.appId }}</td>
          <td>{{ props.item.timeZone }}</td>
          <td>
            <v-icon v-if="props.item.password === ''"
                    class="mx-0"
                    color="orange"
            >
              block
            </v-icon>
          </td>
          <td>
            <v-icon v-if="props.item.lookups"
                    class="mx-0"
                    color="primary"
            >
              done
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import ClientDatabaseTableModal from './ClientDatabaseTableModal'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'client-database-table',
  components: {
    ClientDatabaseTableModal
  },
  props: {
    tableItems: Array
  },
  data() {
    return {
      editItem: null,
      tableHeaders: [{
        text: 'Actions',
        value: false,
        sortable: false
      }, {
        text: 'User Name',
        value: 'userName'
      },
      {
        text: 'Connection Url',
        value: 'connectionUrl'
      },
      {
        text: 'MRxFlow App ID',
        value: 'appId'
      },
      {
        text: 'Time Zone',
        value: 'timeZone'
      },
      {
        text: 'Disabled',
        value: false,
        sortable: false
      },
      {
        text: 'Connected',
        value: false,
        sortable: false
      }]
    }
  },
  methods: {
    cloneDeep: cloneDeep
  }
}
</script>
